import styled from 'styled-components';

export const StyledPlaySimpleSaleBadge = styled.div`
  font-family: var(--font-family), Arial;
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  top: -12px;
  right: -12px;
  background: #4b4cfb;
  aspect-ratio: 1;
  clip-path: polygon(
    100% 50%,
    88.64% 60.35%,
    93.3% 75%,
    78.28% 78.28%,
    75% 93.3%,
    60.35% 88.64%,
    50% 100%,
    39.65% 88.64%,
    25% 93.3%,
    21.72% 78.28%,
    6.7% 75%,
    11.36% 60.35%,
    0% 50%,
    11.36% 39.65%,
    6.7% 25%,
    21.72% 21.72%,
    25% 6.7%,
    39.65% 11.36%,
    50% 0%,
    60.35% 11.36%,
    75% 6.7%,
    78.28% 21.72%,
    93.3% 25%,
    88.64% 39.65%
  );

  .playSimple__sale-badge {
    &__number {
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
    }

    &__text {
      color: white;
      font-size: 12px;
    }
  }
` as any;
